<div class="div-header" #divBar [ngStyle]="{'display': includeDivHeader ? 'block' : 'none'}" [ngClass]="{'inputOpen': this.activeInput}">
  <div class="justify-content-between align-items-center d-flex content">
      <ng-container *ngIf="this.company">
        <div class="div-company" *ngIf="!this.buttonClicked">
          <div class="div-company__logo" >
            <div [ngStyle]="{'background-image': 'url('+ this.imgLogo +')'}"></div>
          </div>
          <div style="padding-left: 10px; display: flex; flex-direction: column;">
            <span class="span-company">{{ this.nameFantasyCompany}}</span>
            <ng-container *ngIf="this.typeParam.type == 1">
              <span class="span-identification">MESA {{ this.typeParam.numberParam }}</span>
            </ng-container>
            <ng-container *ngIf="this.typeParam.type == 2">
              <span class="span-identification">COMANDA {{ this.typeParam.numberParam }}</span>
            </ng-container>

            <ng-container *ngIf="this.placeActive">
              <span class="span-identification">{{ this.placeCounter.placeName }}</span>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <div class="d-flex div-button-for-top" style="gap: 13px;" >
        <button class="icon-content" style="border: 1px solid #a5a2a2;" (click)="scrollToTop()" [ngClass]="{'clicked': isClicked}" *ngIf="!this.buttonClicked">
          <i class="icon-arrow-up" aria-hidden="true" style="font-size: 17px;"></i>
        </button>
        <button  class="button-for-search" (click)="openInput()" #buttonSearch style="width: 30px; height: 30px; border: 1px solid #a5a2a2;" *ngIf="!this.buttonClicked">
          <i class="icon-search" aria-hidden="true" type="button" style="font-size: 17px;"></i>
        </button>

      </div>
  </div>
</div>
